import React from 'react';
import PropTypes from 'prop-types';
import { TAKING_LONG_TIME } from './constants';
import { CircularProgress } from './CircularProgress';

const propTypes = {
	elementId: PropTypes.string,
	timedOut: PropTypes.bool,
	error: PropTypes.instanceOf(Error),
	pastDelay: PropTypes.bool,
};

export const LoadingScreen = ({ error, timedOut, pastDelay, elementId }) => {
	if (error) {
		throw error;
	} else if (timedOut) {
		throw new Error(TAKING_LONG_TIME);
	} else if (pastDelay) {
		return <CircularProgress elementId={elementId} centered autoFocus />;
	}
	return null;
};

LoadingScreen.propTypes = propTypes;
